import { sentenceCase } from '../Shared/StringUtilities';
export var MedicinalProductSearchBy;
(function (MedicinalProductSearchBy) {
    MedicinalProductSearchBy["All"] = "all";
    MedicinalProductSearchBy["MedicinalProductPackOnly"] = "medicinalProductPackOnly";
    MedicinalProductSearchBy["TradeProductPackOnly"] = "tradeProductPackOnly";
})(MedicinalProductSearchBy || (MedicinalProductSearchBy = {}));
export var MedicationValidation;
(function (MedicationValidation) {
    MedicationValidation["Valid"] = "valid";
    MedicationValidation["BrandPrescriptionWarning"] = "brandPrescriptionWarning";
    MedicationValidation["GenericOnLemiException"] = "genericOnLemiException";
    MedicationValidation["GenericOnLmbcException"] = "genericOnLmbcException";
})(MedicationValidation || (MedicationValidation = {}));
export var MedicationStatus;
(function (MedicationStatus) {
    MedicationStatus["Draft"] = "draft";
    MedicationStatus["Finalised"] = "finalised";
    MedicationStatus["Stopped"] = "stopped";
    MedicationStatus["EnteredInError"] = "enteredInError";
})(MedicationStatus || (MedicationStatus = {}));
export var MedicationCourse;
(function (MedicationCourse) {
    MedicationCourse["ShortCourse"] = "shortCourse";
    MedicationCourse["AsRequired"] = "asRequired";
    MedicationCourse["Regular"] = "regular";
    MedicationCourse["Daa"] = "daa";
    MedicationCourse["None"] = "none";
})(MedicationCourse || (MedicationCourse = {}));
export var ConsentDetailStatus;
(function (ConsentDetailStatus) {
    ConsentDetailStatus["NotSet"] = "notSet";
    ConsentDetailStatus["Yes"] = "yes";
    ConsentDetailStatus["No"] = "no";
})(ConsentDetailStatus || (ConsentDetailStatus = {}));
export function prettyPrintMedicationCourse(course) {
    switch (course) {
        case MedicationCourse.ShortCourse:
            return 'Short course';
        case MedicationCourse.AsRequired:
            return 'As required (PRN)';
        case MedicationCourse.Regular:
            return 'Regular medication';
        default:
            return sentenceCase(course !== null && course !== void 0 ? course : '');
    }
}
export var MedicationType;
(function (MedicationType) {
    MedicationType["TakeHomeScript"] = "takeHomeScript";
    MedicationType["MedicationOrder"] = "medicationOrder";
    MedicationType["MedicationHistory"] = "medicationHistory";
    MedicationType["EnrmcScript"] = "enrmcScript";
    MedicationType["ComplementaryTherapyOrder"] = "complementaryTherapyOrder";
})(MedicationType || (MedicationType = {}));
export function prettyPrintMedicationType(type) {
    switch (type) {
        case MedicationType.TakeHomeScript:
            return 'Take home script';
        case MedicationType.MedicationOrder:
            return 'Medication order';
        case MedicationType.MedicationHistory:
            return 'Medication history';
        case MedicationType.EnrmcScript:
            return 'eNRMC script';
        case MedicationType.ComplementaryTherapyOrder:
            return 'Complementary therapy';
        default:
            return sentenceCase(type !== null && type !== void 0 ? type : '');
    }
}
export var OutputType;
(function (OutputType) {
    OutputType["NoOutput"] = "noOutput";
    OutputType["SendScript"] = "sendScript";
    OutputType["PrintScript"] = "printScript";
})(OutputType || (OutputType = {}));
export var OutputStatus;
(function (OutputStatus) {
    OutputStatus["None"] = "none";
    OutputStatus["Submitted"] = "submitted";
    OutputStatus["Accepted"] = "accepted";
    OutputStatus["Expired"] = "expired";
    OutputStatus["Printed"] = "printed";
    OutputStatus["Declined"] = "declined";
    OutputStatus["Redelivered"] = "redelivered";
})(OutputStatus || (OutputStatus = {}));
export var DecisionSupportStatus;
(function (DecisionSupportStatus) {
    DecisionSupportStatus["NotChecked"] = "notChecked";
    DecisionSupportStatus["Passed"] = "passed";
    DecisionSupportStatus["Information"] = "information";
    DecisionSupportStatus["Warning"] = "warning";
    DecisionSupportStatus["Alert"] = "alert";
    DecisionSupportStatus["Error"] = "error";
})(DecisionSupportStatus || (DecisionSupportStatus = {}));
export var DecisionSupportStatusBehaviour;
(function (DecisionSupportStatusBehaviour) {
    DecisionSupportStatusBehaviour["CurrentStatus"] = "currentStatus";
    DecisionSupportStatusBehaviour["ExcludeNotedDecisionSupport"] = "excludeNotedDecisionSupport";
})(DecisionSupportStatusBehaviour || (DecisionSupportStatusBehaviour = {}));
export var PrescriptionMonitoringStatus;
(function (PrescriptionMonitoringStatus) {
    PrescriptionMonitoringStatus["NotChecked"] = "notChecked";
    PrescriptionMonitoringStatus["Passed"] = "passed";
    PrescriptionMonitoringStatus["NotEnabled"] = "notEnabled";
    PrescriptionMonitoringStatus["Acceptable"] = "acceptable";
    PrescriptionMonitoringStatus["Warning"] = "warning";
    PrescriptionMonitoringStatus["Alert"] = "alert";
    PrescriptionMonitoringStatus["Error"] = "error";
})(PrescriptionMonitoringStatus || (PrescriptionMonitoringStatus = {}));
export var MedicationExpiry;
(function (MedicationExpiry) {
    MedicationExpiry["Expired"] = "expired";
    MedicationExpiry["AboutToExpire"] = "aboutToExpire";
    MedicationExpiry["InDate"] = "inDate";
    MedicationExpiry["NoExpiry"] = "noExpiry";
})(MedicationExpiry || (MedicationExpiry = {}));
export var PrescribeUsing;
(function (PrescribeUsing) {
    PrescribeUsing["Generic"] = "generic";
    PrescribeUsing["Brand"] = "brand";
})(PrescribeUsing || (PrescribeUsing = {}));
export var PaymentSchemeType;
(function (PaymentSchemeType) {
    PaymentSchemeType["Private"] = "private";
    PaymentSchemeType["Pbs"] = "pbs";
})(PaymentSchemeType || (PaymentSchemeType = {}));
export var PbsRestrictionType;
(function (PbsRestrictionType) {
    PbsRestrictionType["Unrestricted"] = "unrestricted";
    PbsRestrictionType["Restricted"] = "restricted";
    PbsRestrictionType["AuthorityRequired"] = "authorityRequired";
    PbsRestrictionType["AuthorityRequiredStreamlined"] = "authorityRequiredStreamlined";
})(PbsRestrictionType || (PbsRestrictionType = {}));
export var InstructionType;
(function (InstructionType) {
    InstructionType["FreeTextInstruction"] = "freeTextInstruction";
    InstructionType["DaaInstruction"] = "daaInstruction";
    InstructionType["DosageTimeInstruction"] = "dosageTimeInstruction";
})(InstructionType || (InstructionType = {}));
export var PatientMedicationAllowedAction;
(function (PatientMedicationAllowedAction) {
    PatientMedicationAllowedAction["Finalise"] = "finalise";
    PatientMedicationAllowedAction["Stop"] = "stop";
    PatientMedicationAllowedAction["EnterInError"] = "enterInError";
    PatientMedicationAllowedAction["Represcribe"] = "represcribe";
    PatientMedicationAllowedAction["Delete"] = "delete";
    PatientMedicationAllowedAction["ReviewVto"] = "reviewVto";
    PatientMedicationAllowedAction["ReassignVto"] = "reassignVto";
    PatientMedicationAllowedAction["Adjust"] = "adjust";
})(PatientMedicationAllowedAction || (PatientMedicationAllowedAction = {}));
export var PoisonScheduleStatus;
(function (PoisonScheduleStatus) {
    PoisonScheduleStatus["None"] = "none";
    PoisonScheduleStatus["Warning"] = "warning";
    PoisonScheduleStatus["Alert"] = "alert";
})(PoisonScheduleStatus || (PoisonScheduleStatus = {}));
export var PatientMedicationHistoryStatus;
(function (PatientMedicationHistoryStatus) {
    PatientMedicationHistoryStatus["Draft"] = "draft";
    PatientMedicationHistoryStatus["Finalised"] = "finalised";
    PatientMedicationHistoryStatus["Stopped"] = "stopped";
    PatientMedicationHistoryStatus["EnteredInError"] = "enteredInError";
    PatientMedicationHistoryStatus["Submitted"] = "submitted";
    PatientMedicationHistoryStatus["Accepted"] = "accepted";
    PatientMedicationHistoryStatus["Expired"] = "expired";
    PatientMedicationHistoryStatus["Printed"] = "printed";
    PatientMedicationHistoryStatus["Declined"] = "declined";
    PatientMedicationHistoryStatus["Redelivered"] = "redelivered";
    PatientMedicationHistoryStatus["Updated"] = "updated";
    PatientMedicationHistoryStatus["ElectronicFailure"] = "electronicFailure";
})(PatientMedicationHistoryStatus || (PatientMedicationHistoryStatus = {}));
export var PharmacyRequestHistoryStatus;
(function (PharmacyRequestHistoryStatus) {
    PharmacyRequestHistoryStatus["Created"] = "created";
    PharmacyRequestHistoryStatus["Stopped"] = "stopped";
    PharmacyRequestHistoryStatus["Cancelled"] = "cancelled";
    PharmacyRequestHistoryStatus["EnteredInError"] = "enteredInError";
    PharmacyRequestHistoryStatus["Submitted"] = "submitted";
    PharmacyRequestHistoryStatus["Accepted"] = "accepted";
    PharmacyRequestHistoryStatus["Declined"] = "declined";
    PharmacyRequestHistoryStatus["Sent"] = "sent";
    PharmacyRequestHistoryStatus["ElectronicFailure"] = "electronicFailure";
})(PharmacyRequestHistoryStatus || (PharmacyRequestHistoryStatus = {}));
export var VerbalOrderStatus;
(function (VerbalOrderStatus) {
    VerbalOrderStatus["New"] = "new";
    VerbalOrderStatus["Accepted"] = "accepted";
    VerbalOrderStatus["Rejected"] = "rejected";
})(VerbalOrderStatus || (VerbalOrderStatus = {}));
export var CrossCheckType;
(function (CrossCheckType) {
    CrossCheckType["Provider"] = "provider";
    CrossCheckType["External"] = "external";
})(CrossCheckType || (CrossCheckType = {}));
export var ClinicalIndicationType;
(function (ClinicalIndicationType) {
    ClinicalIndicationType["FreeText"] = "freeText";
    ClinicalIndicationType["Coded"] = "coded";
})(ClinicalIndicationType || (ClinicalIndicationType = {}));
export var CdsStatus;
(function (CdsStatus) {
    CdsStatus["Available"] = "available";
    CdsStatus["Noted"] = "noted";
})(CdsStatus || (CdsStatus = {}));
export var ProductPackGroup;
(function (ProductPackGroup) {
    ProductPackGroup["Unrestricted"] = "Unrestricted";
    ProductPackGroup["Restricted"] = "Restricted";
    ProductPackGroup["AuthorityRequiredStreamlined"] = "AuthorityRequiredStreamlined";
    ProductPackGroup["AuthorityRequired"] = "AuthorityRequired";
    ProductPackGroup["Private"] = "Private";
    ProductPackGroup["S100"] = "S100";
})(ProductPackGroup || (ProductPackGroup = {}));
export var PbsRpbsRestrictionType;
(function (PbsRpbsRestrictionType) {
    PbsRpbsRestrictionType["Unrestricted"] = "Unrestricted";
    PbsRpbsRestrictionType["Restricted"] = "Restricted";
    PbsRpbsRestrictionType["AuthorityRequired"] = "AuthorityRequired";
    PbsRpbsRestrictionType["AuthorityRequiredStreamlined"] = "AuthorityRequiredStreamlined";
})(PbsRpbsRestrictionType || (PbsRpbsRestrictionType = {}));
